import React, { useEffect } from 'react'
import useSafeNavigation from 'hooks/useSafeNavigation'
import { withAppLayout } from 'layouts/AppLayout'
import useFeatureFlags from 'hooks/useFeatureFlags'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getServerSideProps = async () => {
  return {
    props: {
      currentUser: {}
    }
  }
}

const Index = (): JSX.Element => {
  const { safeReplace } = useSafeNavigation()
  const featureFlags = useFeatureFlags()
  const { documentRequests } = featureFlags
  useEffect(() => {
    if (documentRequests === undefined) return //to avoid race condition
    const redirectTo = documentRequests ? '/flows' : '/tasks/my-tasks'
    safeReplace(redirectTo)
  }, [documentRequests, safeReplace])

  return <></>
}

export default withAppLayout(Index)
